/**
 * IST date/time formatting utilities.
 * All public timestamps display in Asia/Kolkata (IST).
 */

const IST_TIMEZONE = "Asia/Kolkata";

export function formatIST(iso: string): string {
  const date = new Date(iso);
  return date.toLocaleString("en-IN", {
    timeZone: IST_TIMEZONE,
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }) + " IST";
}

export function formatTimeIST(iso: string): string {
  const date = new Date(iso);
  return date.toLocaleString("en-IN", {
    timeZone: IST_TIMEZONE,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
}

export function formatTimeISTShort(iso: string): string {
  const date = new Date(iso);
  return date.toLocaleString("en-IN", {
    timeZone: IST_TIMEZONE,
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}

export function formatDateIST(iso: string): string {
  const date = new Date(iso);
  return date.toLocaleString("en-IN", {
    timeZone: IST_TIMEZONE,
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

export function formatDuration(seconds: number): string {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, "0")}`;
}

export function formatDurationWords(seconds: number): string {
  if (seconds < 60) return "less than a minute";
  const mins = Math.round(seconds / 60);
  return `${mins} minute${mins > 1 ? "s" : ""}`;
}

export function formatStageDuration(seconds: number): string {
  if (seconds < 1) return `${Math.round(seconds * 1000)}ms`;
  if (seconds < 60) return `${seconds.toFixed(1)}s`;
  const mins = Math.floor(seconds / 60);
  const secs = Math.round(seconds % 60);
  return `${mins}m ${secs}s`;
}
